module.exports = __webpack_public_path__ + "static/media/1.ba299df1.png";